'use client'

import { useMemo } from 'react'
import { useRouter as useNextRouter } from 'next/navigation'

import { useLocale } from '~/hooks/use-locale.hook'
import { getLocalizedPath } from '~/i18n/routing'

export { useParams, usePathname, useSearchParams } from 'next/navigation'

export const useRouter = () => {
	const locale = useLocale()
	const router = useNextRouter()

	return useMemo(
		() =>
			({
				...router,
				prefetch: (...[href, options]: Parameters<typeof router.prefetch>) =>
					router.prefetch(getLocalizedPath(href, locale), options),
				push: (...[href, options]: Parameters<typeof router.push>) =>
					router.push(getLocalizedPath(href, locale), options),
				replace: (...[href, options]: Parameters<typeof router.replace>) =>
					router.replace(getLocalizedPath(href, locale), options),
			}) satisfies ReturnType<typeof useNextRouter>,
		[locale, router],
	)
}
